import { makeImage } from '../../jsCore/utils/dom'
import { getJsonOrError } from '../../jsCore/utils/fetch'
import { queryString } from '../../jsCore/utils/window'
import { warn, info } from '../../jsCore/application/console'
import { getCampaigns } from '../../jsCore/application/pageDataObject'
import { FANTASY_ACTION_TYPES } from './fantasyActionTypes'
import { transformFantasyTournaments } from './transformers/fantasyTournamentTransformer'

const { TOURNAMENT } = FANTASY_ACTION_TYPES
const { debugFantasyTournaments, mockFantasyTournaments } = queryString
const TOURNAMENTS_MOCK_URL =
  'https://s3-us-west-2.amazonaws.com/90min-widgets/yahoo-fantasy/soccer_tournaments_dummy.json'
const TOURNAMENTS_TRACKING_URLS = {
  PAGE_VIEW:
    'https://ad.doubleclick.net/ddm/trackimp/N1881.206593290MIN/B20215410.203384788;dc_trk_aid=403216671;dc_trk_cid=91973336;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
  CLICK:
    'https://ad.doubleclick.net/ddm/trackclk/N1881.206593290MIN/B20215410.203384788;dc_trk_aid=403216671;dc_trk_cid=91973336;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
}

function loadMoreTournaments() {
  return (dispatch, getState) =>
    dispatch({
      type: TOURNAMENT.LOAD_MORE,
    })
}

function dispatchGetTournamentsFeed(dispatch, tournaments) {
  dispatch({
    type: TOURNAMENT.GET_TOURNAMENTS_FEED,
    state: {
      tournaments,
      isInitialized: true,
    },
  })
  makeImage({ src: TOURNAMENTS_TRACKING_URLS.PAGE_VIEW })
}

function getTournamentsFeed() {
  if (!getCampaigns() || !getCampaigns().yahoo_fantasy) {
    return warn("[YAHOO_FANTASY] can't find yahoo fantasy campaign url", getCampaigns())
  }
  const tournamentsUrlToFetch = mockFantasyTournaments
    ? TOURNAMENTS_MOCK_URL
    : getCampaigns().yahoo_fantasy.tournaments
  if (mockFantasyTournaments) {
    info('[YAHOO_FANTASY] Fetching mock!')
  }
  if (debugFantasyTournaments) {
    info(`[YAHOO_FANTASY] Fetching tournaments from '${tournamentsUrlToFetch}'`)
  }
  return (dispatch, getState) =>
    getJsonOrError(tournamentsUrlToFetch)
      .then(transformFantasyTournaments)
      .then(dispatchGetTournamentsFeed.bind(0, dispatch))
      .catch(warn)
}

function trackTournamentsClick() {
  return makeImage({ src: TOURNAMENTS_TRACKING_URLS.CLICK })
}

function selectTournament() {
  trackTournamentsClick()
  return (dispatch, getState) =>
    dispatch({
      type: TOURNAMENT.SELECT_TOURNAMENT,
    })
}

export const fantasyActions = {
  loadMoreTournaments,
  getTournamentsFeed,
  selectTournament,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyActions.js